<template>
  <v-container
    fluid
    class="pa-0 ma-0"
  >
    <v-card
      flat
      class="pa-0 ma-0"
      color="transparent"
    >
      <v-card-title>
        Cart Items
      </v-card-title>
      <v-card-text
        class="pa-0 ma-0"
      >
        <v-data-table
          :items="displayItems"
          :headers="headers"
          hide-default-footer
          disable-sort
        >
          <template v-slot:item.actions="{ item }">
            <v-icon
              v-if="!item.shipping"
              small
              class="mr-2"
              @click="editItemQty({key: item.idx, qty: item.qty})"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              v-if="!item.shipping"
              small
              @click="confimDeleteItem(item.idx)"
            >
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    
    <are-you-sure
      :opt="dialog"
      @clickedNo="dialog.show = false"
      @clickedYes="dialog.show = false; deleteItem()"
    />

    <v-dialog
      v-model="editDialog"
      max-width="300px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Change Quantity</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                align="middle"
              >
                <v-text-field
                  v-model="editQty"
                  class="inputNumber"
                  type="number"
                  label="Qty"
                  append-outer-icon="mdi-plus-circle"
                  prepend-icon="mdi-minus-circle"
                  @click:append-outer="increment(true)"
                  @click:prepend="increment(false)"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="editDialog=false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="editDialog=false; saveEdit()"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  components:{
  },
  props: {
    items: {
      type: Array,
      default: ()=>[]
    },
    cartTotal: {
      type: Number,
      default: ()=>0
    },
    shipping: {
      type: Object,
      default: ()=>{return {}}
    }
  },
  data: () => ({
    headers: [
      {text: "description", value: "name"},
      {text: "qty", value: "qty"},
      {text: "amt", value: "amount"},
      {value: "actions", align: 'end'},
    ],
    dialog: {
      show: false,
      text: {title: 'Delete this item from your cart?'}
    },
    editDialog: false,
    delIdx: null,
    editKey: null,
    editQty: null,
    defaultItem: {
      qty: 0,
    },
  }),
  computed: {
    displayItems() {
      return this.items.concat(this.shipping.items || [])
    }
  },
  methods: {

    increment(opt) {
      if (opt) {
        this.editQty++
      } else {
        if (this.editQty>1) {
          this.editQty--
        }
      }
    },

    editItemQty(opt) {
      this.editKey = opt.key
      this.editQty = opt.qty
      this.editDialog = true
    },

    confimDeleteItem(idx) {
      this.delIdx = idx
      this.dialog.show = true
    },

    deleteItem() {
      this.$store.commit('market/deleteFromCart', {idx: this.delIdx, shopID: this.context})
    },

    saveEdit () {
      if (this.editKey > -1) {
        this.$store.commit('market/updateQtyInCart', {
          context: this.context,
          idx: this.editKey,
          qty: this.editQty
        })
      }
    },
  },
}
</script>

<style>
.inputNumber input[type='number'] {
    -moz-appearance:textfield;
}
.inputNumber input::-webkit-outer-spin-button,
.inputNumber input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>